import { getSessionData } from '@canvas/frame-api/get-session-data';

import { type RelaySupplierResult } from '../network/socket';
import {
  type Transport,
  type TransportCallbacks,
  type TransportContext,
  createCollabConnectionTransport,
} from '../transport';

import { type CollabStrategy } from './collab-strategy';

const LOCAL_CLOUD_ID = 'DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5';

export class NcsCollabStrategy implements CollabStrategy {
  readonly type = 'ncs' as const;

  createTransport(ctx: TransportContext, callbacks: TransportCallbacks): Transport {
    return createCollabConnectionTransport(ctx, callbacks);
  }

  sendAwareness(
    message: Uint8Array<ArrayBuffer>,
    transport: Transport | undefined,
    fallbackSend: (msg: Uint8Array<ArrayBuffer>) => void
  ): void {
    if (transport?.sendAwareness) {
      transport.sendAwareness(message);
    } else {
      fallbackSend(message);
    }
  }

  getStepsUrl(params: {
    documentId: string;
    headStep: string;
    serverUrl?: string;
    attempt: number;
  }): string {
    const { documentId, headStep, serverUrl } = params;
    if (!serverUrl) {
      throw new Error('serverUrl is required for NCS steps URL');
    }
    return `${serverUrl}/api/_internal/document/${encodeURIComponent(
      documentId
    )}/steps/${headStep}`;
  }

  async getRelayUrl(params: {
    boardId: string;
    attempt: number;
    accessToken: string;
  }): Promise<RelaySupplierResult> {
    const { boardId, accessToken } = params;
    if (!process.env.VITE_NCS_SESSION_URL) {
      throw new Error('VITE_NCS_SESSION_URL is not set.');
    }
    const ncsBasePath =
      typeof globalThis.location !== 'undefined'
        ? `${globalThis.location.protocol}//${globalThis.location.host}`
        : process.env.VITE_NCS_SESSION_URL;

    const isLocal = process.env.NODE_ENV === 'development';
    if (isLocal) {
      return {
        url: `${ncsBasePath}/ncs-canvas/session/ari:cloud:canvas:${LOCAL_CLOUD_ID}:board/${boardId}`,
        accessToken,
      };
    }

    // use PMR in micros
    const { activationId, tenantId } = getSessionData();
    return {
      url: `${ncsBasePath}/ncs-canvas/${tenantId}/${activationId}/confluence`,
      namespace: `ncs-canvas/session/ari:cloud:canvas:${LOCAL_CLOUD_ID}:board/${boardId}`,
      accessToken,
    };
  }

  shouldRefreshRelayDetails(): boolean {
    return true;
  }
}
